import { api } from "@/services/api"
import { queryClient } from "@/queryClient"

export const cancelPaymentRequest = async (
  paymentRequestId: string
) => {
  await api.post(
    `/services/payments/${paymentRequestId}/cancel/`
  )

  queryClient.invalidateQueries([
    PAYMENT_REQUESTS_QUERY_KEY,
  ])
}
